// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: lLCcoonTe6o
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import NavLink from "../../NavLink"; // plasmic-import: mfFSfJvg76/component
import { useScreenVariants as useScreenVariantsrrBukHdQcoc } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: rrBukHDQcoc/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicNavBar2.module.css"; // plasmic-import: lLCcoonTe6o/css
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: X9wy9k55W-u/icon
import logoBasilCxe13PngE8262E708472A4750C2EPngVZhE2SM1DN from "./images/logoBasilCxe13PngE8262E708472A4750C2EPng.png"; // plasmic-import: vZhE2_sM-1dN/picture

createPlasmicElementProxy;

export const PlasmicNavBar2__VariantProps = new Array();

export const PlasmicNavBar2__ArgProps = new Array("buttonLink");

const $$ = {};

function PlasmicNavBar2__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsrrBukHdQcoc()
  });
  return (
    <Stack__
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <PlasmicLink__
        className={classNames(projectcss.all, projectcss.a, sty.link__v3Bjc)}
        href={`/`}
        platform={"react"}
      >
        <PlasmicImg__
          data-plasmic-name={"img"}
          data-plasmic-override={overrides.img}
          alt={""}
          className={classNames(sty.img)}
          displayHeight={"48px"}
          displayMaxHeight={"none"}
          displayMaxWidth={"none"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"9em"}
          src={{
            src: logoBasilCxe13PngE8262E708472A4750C2EPngVZhE2SM1DN,
            fullWidth: 3179,
            fullHeight: 828,
            aspectRatio: undefined
          }}
        />
      </PlasmicLink__>
      <Stack__
        as={"div"}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox___5HpXd)}
      >
        <NavLink
          className={classNames("__wab_instance", sty.navLink___6SIji)}
          navLinkProp={`/global-rankings`}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__v5Efs
            )}
          >
            {"Global Index"}
          </div>
        </NavLink>
        <NavLink
          className={classNames("__wab_instance", sty.navLink__l1Tgw)}
          navLinkProp={`/basil-tiles`}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__lcpNx
            )}
          >
            {"Datasets"}
          </div>
        </NavLink>
        <NavLink
          className={classNames("__wab_instance", sty.navLink__uaMnB)}
          navLinkProp={`/community-page`}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__zs28Q
            )}
          >
            {"Community"}
          </div>
        </NavLink>
        <NavLink
          className={classNames("__wab_instance", sty.navLink__fwqv1)}
          navLinkProp={"https://dashboard.basillabs.org/signin"}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__dsTYr
            )}
          >
            {"Sign in"}
          </div>
        </NavLink>
        <PlasmicLink__
          data-plasmic-name={"greenButton3"}
          data-plasmic-override={overrides.greenButton3}
          className={classNames(projectcss.all, projectcss.a, sty.greenButton3)}
          href={`/contact-us`}
          platform={"react"}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__kJaJr
            )}
          >
            {"Chat with us"}
          </div>
        </PlasmicLink__>
      </Stack__>
      {false ? (
        <div className={classNames(projectcss.all, sty.freeBox__uGtD7)}>
          <button
            data-plasmic-name={"button"}
            data-plasmic-override={overrides.button}
            className={classNames(
              projectcss.all,
              projectcss.button,
              projectcss.__wab_text,
              sty.button
            )}
          >
            {"Sign up"}
          </button>
          <Stack__
            as={PlasmicLink__}
            hasGap={true}
            className={classNames(projectcss.all, projectcss.a, sty.link__n2EL)}
            platform={"react"}
          >
            {false ? (
              <IconIcon
                className={classNames(projectcss.all, sty.svg__zhQtz)}
                role={"img"}
              />
            ) : null}
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___5E8UU
              )}
            >
              {"Log in"}
            </div>
            {false ? (
              <IconIcon
                className={classNames(projectcss.all, sty.svg__vhcug)}
                role={"img"}
              />
            ) : null}
          </Stack__>
        </div>
      ) : null}
    </Stack__>
  );
}

const PlasmicDescendants = {
  root: ["root", "img", "greenButton3", "button"],
  img: ["img"],
  greenButton3: ["greenButton3"],
  button: ["button"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNavBar2__ArgProps,
          internalVariantPropNames: PlasmicNavBar2__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicNavBar2__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNavBar2";
  } else {
    func.displayName = `PlasmicNavBar2.${nodeName}`;
  }
  return func;
}

export const PlasmicNavBar2 = Object.assign(
  // Top-level PlasmicNavBar2 renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    img: makeNodeComponent("img"),
    greenButton3: makeNodeComponent("greenButton3"),
    button: makeNodeComponent("button"),
    // Metadata about props expected for PlasmicNavBar2
    internalVariantProps: PlasmicNavBar2__VariantProps,
    internalArgProps: PlasmicNavBar2__ArgProps
  }
);

export default PlasmicNavBar2;
/* prettier-ignore-end */
